import { Tooltip } from 'antd';
import { useState } from 'react';

import { Button } from '@/components/Shared/ui';
import { InfoCircleOutlined } from '@/media/antd-icons';
import PlusIcon from '@/media/icons/plus.svg?react';

import { CreateRequestByTypeModal } from '../../entities';
import { useCheckDealerForLeasing } from '../../hooks';

type TProps = {
  onCreateForIeClick: () => void;
  onCreateForLlpClick: () => void;
};

const LeasingHeader: React.FC<TProps> = ({
  onCreateForIeClick,
  onCreateForLlpClick
}) => {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  const { isCurrentDealerAvailableForLeasing, currentDealerName } =
    useCheckDealerForLeasing();

  return (
    <div className="legal-entity-leasings__header">
      <div className="legal-entity-leasings__header-title">
        <h2>Заявления</h2>
        <p>Созданные заявки на лизинг</p>
      </div>
      {isCurrentDealerAvailableForLeasing ? (
        <div className="legal-entity-leasings__header-pagination">
          <Button
            size="big"
            variant="filled-red"
            onClick={() => setIsCreateModalOpen(true)}
          >
            Новая заявка
            <PlusIcon />
          </Button>
        </div>
      ) : (
        <Tooltip
          placement="bottomRight"
          title={
            <p>
              Создание заявки недоступно: выбранный дилерский центр{' '}
              <b>{currentDealerName}</b> не отмечен как доступный для лизинга.
              Убедитесь, что дилерский центр доступен для лизинга, затем
              очистите кэш. Если после этого проблема остается, обратитесь к
              администратору.
            </p>
          }
        >
          <span className="legal-entity-leasings__header-dealer-warning">
            Создание заявки не доступно <InfoCircleOutlined />
          </span>
        </Tooltip>
      )}

      <CreateRequestByTypeModal
        isOpen={isCreateModalOpen}
        onClose={() => setIsCreateModalOpen(false)}
        onCreateForIeClick={onCreateForIeClick}
        onCreateForLlpClick={onCreateForLlpClick}
      />
    </div>
  );
};

export default LeasingHeader;
